import { isMagasinOpened, hasMagasinHoraires } from "@/utils/magasin";

export const headerMagasinProps = () => ({
  isNational: {
    type: Boolean,
    default: true
  },
  magasin: {
    type: Object,
    required: false,
    default: null
  },
  shopName: {
    type: String,
    required: false,
    default: null
  },
  shopPhone: {
    type: String,
    required: false,
    default: null
  },
  shopCity: {
    type: String,
    required: false,
    default: null
  },
  shopZipCode: {
    type: String,
    required: false,
    default: null
  },
  shopAddress: {
    type: String,
    required: false,
    default: null
  },
  shopfirstSlotAvailable: {
    type: String,
    required: false,
    default: null
  },
  webAlias: {
    type: String,
    required: false,
    default: ""
  },
  shopId: {
    type: Number,
    required: false,
    default: null
  },
  isPro: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const useHeaderMagasin = (props) => {
  const isOpened = computed(() => {
    return isMagasinOpened(props.magasin);
  })
  const showIfOpened = computed(() => {
    return hasMagasinHoraires(props.magasin);
  })

  return {
    isOpened,
    showIfOpened
  }
}

